import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

function FullLoader() {
  return (
    <div className="grid min-h-screen place-items-center bg-cream">
      <div className="animate-pulse"><Logo size={48} /></div>
    </div>
  );
}

export function ProtectedRoute({ children, requireExam = true }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <FullLoader />;
  if (!user) return <Navigate to="/connexion" replace />;
  if (requireExam && user.role === "student" && !user.exam_id) return <Navigate to="/bienvenue" replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <FullLoader />;
  if (!user) return <Navigate to="/connexion" replace />;
  if (user.role !== "admin") return <Navigate to="/app" replace />;
  return children;
}
